import { StyleSheet } from 'react-native';

export const featureStyles = StyleSheet.create({
  container: {
    marginHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  descText: {
    marginHorizontal: 10,
    color: '#606470',
    fontSize: 13,
    marginBottom: 6,
  },
  arrow: {
    fontSize: 20,
    color: 'orange',
  },
  imageContainer: {
    paddingHorizontal: 10,
    marginTop: 10,
    backgroundColor: '#ced4da',
    // backgroundColor: '#F6F5F8',
    padding: 10,
  },
});
